import { createContext, useContext } from 'react';
import type { Dispatch } from 'react';
import type {
    CollapsedBarMode,
    ModeEvents,
} from './collapsibleBarModeReducer.ts';

export type CollapsibleBarsContextValue = Record<
    CollapsibleBarSide,
    {
        disabled: boolean;
        mode: CollapsedBarMode;
        modeTransition: Dispatch<ModeEvents>;
        width: number;
        collapsedWidth: number;
    }
>;
export const CollapsibleBarsContext =
    createContext<CollapsibleBarsContextValue | null>(null);

export const useCollapsibleBarsContext = () => {
    const ctx = useContext(CollapsibleBarsContext);
    if (!ctx) {
        throw new Error(
            'Consuming the `CollapsibleBarsContext` outside its Provider. You need to wrap the `Children` to `CollapsibleBars`. ',
        );
    }
    return ctx;
};
export type CollapsibleBarSide = 'left' | 'right';
